"use client";

import { Search, SlidersHorizontalIcon } from "lucide-react";
import { useRouter, useSearchParams } from "next/navigation";
import { useCallback, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import { BlogTags } from "./blog-tags";
import { BlogSort } from "./blog-sort";
import { Category, Pathology, Tag } from "@/app/types/blogTypes";
import { BottomSheet } from "./bottom-sheet";

interface BlogSearchBarProps {
  pathologies: Pathology[];
  categories: Category[];
  tags: Tag[];
}

export function BlogSearchBar({ tags }: BlogSearchBarProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [searchTerm, setSearchTerm] = useState(
    searchParams.get("search") || ""
  );
  const [isOpen, setIsOpen] = useState(false);

  const debouncedSearch = useDebouncedCallback((term: string) => {
    const params = new URLSearchParams(searchParams);
    if (term) {
      params.set("search", term);
    } else {
      params.delete("search");
    }
    router.push(`/blog/?${params.toString()}`);
  }, 300);

  const handleSearch = useCallback(
    (term: string) => {
      setSearchTerm(term);
      debouncedSearch(term);
    },
    [debouncedSearch]
  );

  return (
    <>
      <div className="flex w-full items-center justify-between gap-1 max-w-[1200px] mx-auto ">
        {" "}
        <div className="hidden gap-4 md:flex">
          <BlogTags tags={tags} />
          <BlogSort />
        </div>
        <button
          onClick={() => setIsOpen(true)}
          className="min-w-10 min-h-10 relative items-center justify-center flex md:hidden"
        >
          <SlidersHorizontalIcon size={18} className="text-brand-darker" />
        </button>
        <div className="relative w-full max-w-[240px] md:max-w-[320px] md:flex-shrink-0">
          {" "}
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#A9A9A9]" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Buscar pelo conteúdo"
            className="pl-10 text-base w-full max-w-[240px] md:max-w-[320px] h-12 px-4 rounded-2xl border focus:ring-0 focus:outline-none text-gray-900 placeholder-neutral-400"
          />
        </div>
      </div>
      <BottomSheet
        tags={tags}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
